(() => {
  'use strict';

  if (window.__bmSelectedVehicleProductsRuntime) return;
  window.__bmSelectedVehicleProductsRuntime = true;

  const SOURCE_SECTION_ID = 'bm-vehicle-product-source';
  const HOST_SELECTOR = '[data-bm-selected-vehicle-products]';
  const requestState = new WeakMap();

  const getVehicle = () => window.BandenmeestersVehicle?.getActive?.() || null;

  const labelVehicle = (vehicle) => {
    if (!vehicle) return '';
    const api = window.BandenmeestersVehicle;
    if (api?.vehicleLabel) return api.vehicleLabel(vehicle);
    return [vehicle.brand?.name, vehicle.generation?.name || vehicle.model?.name].filter(Boolean).join(' ');
  };

  const fetchSource = async (url, signal) => {
    let lastError;

    for (let attempt = 0; attempt < 2; attempt += 1) {
      try {
        const response = await fetch(url, {
          credentials: 'same-origin',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'text/html'
          },
          signal
        });

        if (!response.ok) throw new Error(`HTTP ${response.status}`);

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const source = doc.querySelector('[data-bm-vehicle-products-source]');
        if (!source) throw new Error('Productbron ontbreekt in sectierespons');
        return source;
      } catch (error) {
        if (error?.name === 'AbortError') throw error;
        lastError = error;
      }
    }

    throw lastError || new Error('Passende sets konden niet worden geladen');
  };

  const loadForHost = async (host) => {
    if (!host?.isConnected) return;

    const previous = requestState.get(host);
    previous?.controller?.abort();

    const vehicle = getVehicle();
    const generationUrl = vehicle?.generation?.url;
    const grid = host.querySelector('[data-bm-vehicle-products-grid]');
    const empty = host.querySelector('[data-bm-vehicle-products-empty]');
    const label = host.querySelector('[data-bm-vehicle-products-label]');
    const allLink = host.querySelector('[data-bm-vehicle-products-all]');
    const currentProductId = String(host.dataset.currentProductId || '');

    if (!generationUrl || !grid) {
      host.hidden = true;
      if (grid) grid.innerHTML = '';
      return;
    }

    const controller = new AbortController();
    const requestId = `${Date.now()}-${Math.random()}`;
    requestState.set(host, { controller, requestId });
    host.dataset.bmVehicleProductsLoading = 'true';
    host.hidden = true;

    if (label) label.textContent = labelVehicle(vehicle);
    if (allLink) allLink.href = generationUrl;

    try {
      const endpoint = new URL(generationUrl, window.location.origin);
      endpoint.searchParams.set('section_id', SOURCE_SECTION_ID);
      const source = await fetchSource(endpoint.toString(), controller.signal);

      if (!host.isConnected || requestState.get(host)?.requestId !== requestId) return;

      const cards = [...source.querySelectorAll('[data-bm-vehicle-product-id]')]
        .filter((card) => String(card.dataset.bmVehicleProductId || '') !== currentProductId)
        .slice(0, 4);

      grid.innerHTML = '';
      cards.forEach((card) => grid.appendChild(card));

      const hasCards = cards.length > 0;
      grid.hidden = !hasCards;
      if (empty) empty.hidden = hasCards;
      host.hidden = false;
    } catch (error) {
      if (error?.name !== 'AbortError') {
        console.error('Bandenmeesters passende sets:', error);
        if (host.isConnected && requestState.get(host)?.requestId === requestId) {
          grid.innerHTML = '';
          host.hidden = true;
        }
      }
    } finally {
      if (host.isConnected && requestState.get(host)?.requestId === requestId) {
        host.dataset.bmVehicleProductsLoading = 'false';
      }
    }
  };

  const collectHosts = (scope = document) => {
    const hosts = [];
    if (scope?.matches?.(HOST_SELECTOR)) hosts.push(scope);
    scope?.querySelectorAll?.(HOST_SELECTOR).forEach((host) => hosts.push(host));
    return hosts;
  };

  const refresh = (scope = document) => {
    collectHosts(scope).forEach((host) => loadForHost(host));
  };

  const refreshAll = () => refresh(document);

  const boot = () => {
    refreshAll();

    window.addEventListener('bm:vehicle:change', refreshAll);
    document.addEventListener('bm:vehicle:ready', refreshAll);
    window.addEventListener('pageshow', refreshAll);

    document.addEventListener('shopify:section:load', (event) => {
      refresh(event.target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      collectHosts(event.target).forEach((host) => {
        requestState.get(host)?.controller?.abort();
        requestState.delete(host);
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();